import { useLensApp } from "../useLensApp.jsx";

export default function ApiCallsSection() {
  const { apiCalls } = useLensApp();

  return (
    <section>
      <h3>API Calls</h3>
      <div id="endpointList">
        {apiCalls.map((call, index) => (
          <div className="endpoint" key={`${call.method}:${call.path}:${index}`}>
            <div className="endpoint-head">
              <span className="method">{call.method}</span>
              <span className="endpoint-path">{call.path}</span>
            </div>
            {call.body && <code>{JSON.stringify(call.body)}</code>}
          </div>
        ))}
      </div>
    </section>
  );
}
